import React, { type JSX } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { CTabs } from '@web-kc/shared/ui';
import { useTranslation } from 'next-i18next';
import { useApp } from '@web-kc/core/providers';
import { ResponsiveBlock } from '@web-kc/shared/components';

interface Props {
  tab: 'lots' | 'tenders';
  onTabChange: (tab: 'lots' | 'tenders') => void;
}

export const TenderHeader = ({ tab, onTabChange }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation(['cabinet']);
  const isKc = useApp() === 'kc';

  const tabColor = (key: string) =>
    tab === key ? 'white' : isKc ? 'text.primary' : 'primary.main';

  const typeTabs = [
    { title: 'myTenders.lots', key: 'lots' },
    { title: `myTenders.tenders.${isKc ? 'kc' : 'rti'}`, key: 'tenders' },
  ];

  const tabItems: { key: string; title: string | JSX.Element }[] = typeTabs.map(
    (r) => ({
      key: r.key,
      title: (
        <Box gap={1} display="flex" alignItems="center">
          <Typography color={tabColor(r.key)}>
            {t(`cabinet:${r.title}`)}
          </Typography>
        </Box>
      ),
    }),
  );

  return (
    <>
      <ResponsiveBlock variant="mobile">
        <CTabs
          size="small"
          tabLabelKey="title"
          tabValueKey="key"
          tabs={tabItems}
          value={tab}
          onChange={onTabChange}
        />
      </ResponsiveBlock>

      <ResponsiveBlock variant="desktop">
        <Grid
          container
          sx={{
            paddingBottom: '15px',
            borderBottom: `1px solid ${theme.palette.grey['300']}`,
          }}
        >
          <Grid size={{ xs: 5.5 }}>
            <CTabs
              size="small"
              tabLabelKey="title"
              tabValueKey="key"
              tabs={tabItems}
              value={tab}
              onChange={onTabChange}
            />
          </Grid>
          <Grid size={{ xs: 2 }} textAlign="start">
            <Typography variant="body2" fontWeight={700}>
              {t('cabinet:myTenders.ending')}
            </Typography>
          </Grid>
          <Grid size={{ xs: 4.5 }} textAlign="end">
            <Typography variant="body2" fontWeight={700}>
              {t('cabinet:favorites.volume')}
            </Typography>
          </Grid>
        </Grid>
      </ResponsiveBlock>
    </>
  );
};
